import vArrow from "./v-arrow.vue";

export default Vue => {
  Vue.component("v-arrow", vArrow);
};
